import { analyticsApi } from './apiManager';

class SessionCompletionService {
  async markSessionCompleted(sessionId: string | number): Promise<{ success: boolean; error?: string }> {
    try {
      const response = await analyticsApi.markSessionCompleted(sessionId);
      
      if (!response.success) {
        throw new Error(response.error || 'Failed to mark session as completed');
      }

      return { success: true };
    } catch (error) {
      console.error('Error marking session as completed:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to mark session as completed'
      };
    }
  }
}

export const sessionCompletionService = new SessionCompletionService();
